import React, { useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import { injectIntl } from '@s7ui-kit/s7ui-kit';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';
import getResizeImageUrl from '../../../services/utils/getResizeImageUrl';

import pushGA from "../../../services/utils/pushGA";

import '../new-mainpage/small-banner.scss';

const mapStateToProps = ({App, User}) => ({App, User});

let alreadyShowned = [];

const SmallBanner = (props) => {
    const { App: { lang, deviceWidth }, data: { tagText,  settings: { tagBgColor, tagTextColor }}, onBannerClick} = props;

    const [ bgImg, setBgImg ] = useState();
    const [ bgByLang, setBgByLang ] = useState();
    const [ title, setTitle ] = useState();
    const [ titleColor, setTitleColor ] = useState();
    const [ text, setText ] = useState();
    const [ textColor, setTextColor ] = useState();
    const [ link, setLink ] = useState();
    const [ linkText, setLinkText ] = useState();
    const [ gotBanner, setGotBanner ] = useState(false);
    const [ isCommon, setIsCommon ] = useState(false);
    const [ type, setType ] = useState('Common');
    const [ background, setBackground ] = useState();
    const [ border, setBorder ] = useState();
    const [ buttonType, setButtonType ] = useState();
    const [ code, setCode ] = useState('');

    let productPlace = useRef(null);

    useEffect(() => {

        const {
            data: {image,
                imageByLanguage,
                link,
                linkText,
                title,
                content,
                code,
                settings: {
                    bgColor,
                    titleColor,
                    textColor,
                    showBorder,
                    buttonType,
                    tagBgColor,
                    tagTextColor,
            }
        }} = props;

        setBgImg(image);
        setBgByLang(imageByLanguage);
        setTitle(title);
        setText(content);
        setLink(link);
        setLinkText(linkText);
        setGotBanner(true);
        setBackground(bgColor);
        setTitleColor(titleColor);
        setTextColor(textColor);
        setBorder(showBorder);
        setButtonType(buttonType);
        if(code) setCode(code);

        const callback = () =>  {
            if (alreadyShowned.indexOf(code) > -1) {
                return;
            }

            alreadyShowned.push(code);
            sendGaEvent('Show', code);
        };

        const options = {
            rootMargin: '0px',
            threshold: 1.0
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(productPlace);

        sendGaEvent('Load', code);

        // axios.get("/S7WAdsService/api/v1/recommendation/diamonds", {
        //     params: {
        //         lang: lang,
        //         ns: 'default',
        //         place: place,
        //     }
        // }).then((response) => {
        //     if ( response.data.length > 0 ) {
        //         const {
        //             image,
        //             imageByLanguage,
        //             link,
        //             linkText,
        //             title,
        //             content,
        //             settings: {
        //                 bgColor,
        //                 titleColor,
        //                 textColor,
        //                 showBorder,
        //                 buttonType
        //             }
        //         } = response.data[0];
        //
        //         console.log("_DATA_",response.data[0])
        //
        //         setBgImg(image);
        //         setBgByLang(imageByLanguage);
        //         setTitle(title);
        //         setText(content);
        //         setLink(link);
        //         setLinkText(linkText);
        //         setGotBanner(true);
        //         setBackground(bgColor);
        //         setTitleColor(titleColor);
        //         setTextColor(textColor);
        //         setBorder(showBorder);
        //         setButtonType(buttonType);
        //
        //         const callback = () =>  {
        //             if (!title) {
        //                 return;
        //             }
        //
        //             if (alreadyShowned) {
        //                 return;
        //             }
        //
        //             alreadyShowned = true;
        //             sendGaEvent('Show', title);
        //         };
        //
        //         const options = {
        //             rootMargin: '0px',
        //             threshold: 1.0
        //         };
        //         const observer = new IntersectionObserver(callback, options);
        //         observer.observe(productPlace);
        //
        //         sendGaEvent('Load', title);
        //     } else {
        //         setGotBanner(false);
        //     }
        // }).catch(() => {
        //     setGotBanner(false);
        // });
    }, []);

    const getBgImage = () => {
        if (bgByLang || bgImg) {
            return getResizeImageUrl({
                typeResize: 'crop',
                width: '320',
                height: '130',
                imageCabinId: bgByLang ? bgByLang : bgImg
            })
        } else {
            return '';
        }
    };

    const sendGaEvent = ( label, code ) => {
        if ( isCommon ) {
            setType('Personal');
        }

        pushGA(
            'PORTAL Banners',
            `${type} ${label}`,
            `CONTENT:smallMain;NAME:${code};`,
            { eventValue: 1 },
        );
    };

    return (
        <div
            ref={ref => {
                if (!ref) {
                    return;
                }
                productPlace = ref;
            }}
        >
            {tagText &&
            <div className='small-banner-label'
                 style={{
                     backgroundColor: tagBgColor ? tagBgColor : '#97BA1E',
                     color: tagTextColor ? tagTextColor : '#FFF',
                 }}>
                {tagText}
            </div>
            }
            {gotBanner && <div
                className={classNames({
                    'small-banner': true,
                    'small-banner-border': !!border
                })}
                id={'small-banner'}
                style={{
                    background: background,
                }}
            >
                <LazyLoad>
                    <div
                        className={'small-banner-image'}
                        style={{
                            backgroundImage: 'url(' + getBgImage() + ')'
                        }}
                    />
                </LazyLoad>
                <div className={'small-banner-info'}>
                    <div className={'small-banner-description'}>
                        {title && <h2
                            className={'small-banner-title'}
                            dangerouslySetInnerHTML={{__html: title}}
                            style={{
                                color: titleColor
                            }}
                        />}

                        {text && <div
                            className={'small-banner-text'}
                            dangerouslySetInnerHTML={{__html: text}}
                            style={{
                                color: textColor
                            }}
                        />}
                    </div>

                    {link && <a
                        className={classNames({
                            'small-banner-button': true,
                            [`small-banner-button-${buttonType}`]: true
                        })}
                        href={link}
                        dangerouslySetInnerHTML={{__html: linkText}}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={() => {
                            sendGaEvent('Click', code);
                            onBannerClick();
                        }}
                    />}
                </div>
            </div>
            }
        </div>
    );
};


export default injectIntl(connect(mapStateToProps)(React.memo(SmallBanner)));